// extracted by mini-css-extract-plugin
export var app_download_buttons_wrapper = "footer-module--app_download_buttons_wrapper--44938";
export var early_access_button = "footer-module--early_access_button--42a34";
export var footer = "footer-module--footer--a2fe4";
export var footer_menu = "footer-module--footer_menu--b4424";
export var footer_wrapper = "footer-module--footer_wrapper--b0084";
export var social_links_wrapper = "footer-module--social_links_wrapper--991f6";